import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ViewWrapper from './ViewWrapper/ViewWrapper';
import { switchMapView } from '../../actions/miniMapActions';
import {
  fetchPublicTour,
  setPublicTourStopInfo,
} from '../../actions/publicTourActions';
import { fetchPublicTourLanguages } from 'actions/translationsActions';
import {
  hideStopDescription,
  showStopDescription,
} from '../../actions/publicTourActions';
import { toggleMainMediaStatus } from '../../actions/mediaActions';
import { sendHubspotEvent } from '../../actions/hubspotActions';
import {
  fetchPreviewTour,
  fetchAvailableLanguages,
} from '../../actions/previewTourActions';

const mapStateToProps = state => {
  const {
    aid,
    tours,
    panos,
    images,
    videos,
    audio,
    stops,
    tier,
    active,
    analyticsMeasurementId,
    analyticsContainerId,
    captureHigherEdTrackingId,
    mapboxToken,
    customScript,
    stopDescriptionMinimized,
    accountPermissions,
  } = state.publicTour;
  const { publishedTourLanguages } = state.translations;
  const { isMainMediaPlaying } = state.media;
  const { show } = state.miniMap;
  if (tours) {
    return {
      aid,
      tours,
      panos,
      images,
      videos,
      audio,
      stops,
      tier: tier,
      mapboxToken,
      customScript,
      miniMapView: show,
      active,
      analyticsMeasurementId,
      analyticsContainerId,
      captureHigherEdTrackingId,
      stopDescriptionMinimized,
      isMainMediaPlaying: isMainMediaPlaying,
      tourLanguages: publishedTourLanguages,
      accountPermissions,
    };
  } else {
    return {
      aid,
      tours: {},
      panos: {},
      stops: {},
      images: {},
      videos: {},
      audio: {},
      tier: {},
      miniMapView: state.miniMap.show,
      active: true,
      stopDescriptionMinimized: state.stops.stopDescriptionMinimized,
      isMainMediaPlaying: state.media.isMainMediaPlaying,
      tourLanguages: state.translations.publishedTourLanguages,
    };
  }
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      switchMapView,
      fetchPublicTour,
      fetchPublicTourLanguages,
      hideStopDescription,
      showStopDescription,
      toggleMainMediaStatus,
      sendHubspotEvent,
      fetchPreviewTour,
      fetchAvailableLanguages,
      setPublicTourStopInfo,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewWrapper);
